import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

interface FilterStoreProps {
  control: any;
  storesData: any[];
  errors: any;
}

export function FilterStore({ control, storesData }: FilterStoreProps) {
  return (
    <FormField
      control={control}
      name="store"
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel className="block text-sm font-medium text-gray-700">
            Loja
          </FormLabel>
          <FormControl>
            <Select value={field.value} onValueChange={field.onChange}>
              <SelectTrigger className="flex items-center w-full h-[50px] px-4 py-2 border rounded-lg text-left text-gray-700 shadow-sm">
                <SelectValue placeholder="Selecione a loja" />
              </SelectTrigger>
              <SelectContent className="w-[--radix-select-trigger-width]">
                {storesData?.map((accountingAccount: { code: { toString: () => any } }) => (
                  <SelectItem
                    key={accountingAccount.code.toString()}
                    value={accountingAccount.code.toString()}
                    className="text-gray-700"
                  >
                    Loja {accountingAccount.code.toString()}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}